import { useCallback } from 'react';

import { Button, Form, Input } from 'antd';

import { NotificationsTypes } from '@/interfaces/notificationsTypes';
import { useUpdateUserMutation } from '@/services/user';
import styled, { css, StyledProp } from '@/styled';

interface PasswordStudentProps extends StyledProp {
  name: string;
  email: string;
  type: number;
  avatar?: string;
  notification: (message: string, type: NotificationsTypes) => void;
}

const PasswordStudent = ({ className, name, email, type, avatar, notification }: PasswordStudentProps) => {
  const [form] = Form.useForm();

  const [updateProfile] = useUpdateUserMutation();

  const savePassword = useCallback(
    async (values: any) => {
      try {
        await updateProfile({ ...values, name, email, type, avatar });
        notification('Senha atualizada com sucesso', NotificationsTypes.SUCCESS);
      } catch {
        notification('Ocorreu um erro ao atualizar senha', NotificationsTypes.ERROR);
      }

      form.resetFields();
    },
    [avatar, email, form, name, notification, type, updateProfile]
  );

  return (
    <div className={className}>
      <Form form={form} layout='vertical' size='large' onFinish={savePassword} autoComplete='off'>
        <Form.Item
          label='Senha Atual'
          name='current-password'
          hasFeedback
          rules={[{ required: true, message: 'Digite a sua senha atual' }]}
        >
          <Input.Password placeholder='Digite a sua senha atual aqui' />
        </Form.Item>
        <Form.Item
          label='Nova Senha'
          name='new-password'
          hasFeedback
          rules={[{ required: true, message: 'Digite sua nova senha' }]}
        >
          <Input.Password placeholder='Digite sua nova senha aqui' />
        </Form.Item>
        <Form.Item
          label='Confirme sua nova senha'
          name='confirm-new-password'
          dependencies={['new-password']}
          hasFeedback
          rules={[
            {
              required: true,
              message: 'Confirme sua senha'
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('new-password') === value) {
                  return Promise.resolve();
                }

                return Promise.reject(new Error('As duas senha não são iguais!'));
              }
            })
          ]}
        >
          <Input.Password placeholder='Confirme sua senha aqui' />
        </Form.Item>
        <Form.Item>
          <Button type='primary' size='large' className='password-student-btn' htmlType='submit'>
            Alterar Senha
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default styled(PasswordStudent)(
  ({ theme }) => css`
    .password-student-btn {
      background-color: ${theme.colorText};
      margin-top: ${theme.space.spacing(4)};

      ${theme.breakpoints.down('md')} {
        width: 100%;
      }
    }

    [title='Senha Atual'],
    [title='Nova Senha'],
    [title='Confirme sua nova senha'] {
      color: ${theme.colorTextSecondary} !important;
    }
  `
);
